<template>
<div>
  <section class="content-header">
    <h1>
      学生数据
      <small>学习数据</small>
    </h1>
    <ol class="breadcrumb">
      <li><a href="#/"><i class="fa fa-dashboard"></i> Home</a></li>
      <li><a href="#/learnDetails/learnDetails">学习数据</a></li>
      <li class="active">学生数据</li>
    </ol>
  </section>

  <section class="content">
    <el-card class="box-card" body-style="padding-bottom:0px">
      <el-form :inline="true" :model="filters">
				<el-form-item v-if="$auth.check('ROLE_SCHOOL')">
          <el-cascader style="width: 360px"
            placeholder="学校及班级"
            expand-trigger="hover"
            :options="orgClasses"
            v-model="filters.orgClass">
          </el-cascader>
				</el-form-item>
        <el-form-item v-if="$auth.check('ROLE_QOOCO')">
          <el-select v-model="filters.customer" filterable clearable placeholder="学校" @change="changeSchool" style="width: 360px">
            <el-option
              v-for="item in customers"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
				<el-form-item v-if="$auth.check('ROLE_QOOCO')">
          <el-select v-model="filters.classId" filterable clearable placeholder="班级" style="width: 300px">
            <el-option
              v-for="item in classes"
              :key="item.group_id"
              :label="item.name"
              :value="item.group_id">
            </el-option>
          </el-select>
				</el-form-item>
        <el-form-item>
          <el-date-picker v-model="filters.dateRange" type="daterange" start-placeholder="开始日期"
            end-placeholder="结束日期" :picker-options="pickerOptions" :default-value="currentDate" value-format="yyyy-MM-dd">
          </el-date-picker>
				</el-form-item>
        <el-form-item v-show="$auth.check('ROLE_QOOCO')">
          <el-select v-model="filters.orgType" filterable clearable placeholder="机构类型">
            <el-option
              v-for="item in orgTypes"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="query">查询</el-button>
				</el-form-item>
			</el-form>
      <div class="duration">
        <span class="label">当前查询时间段：</span>
        <span class="value">{{dateRange[0]}} 至 {{dateRange[1]}}</span>
      </div>
    </el-card>

    <el-card class="box-card">
      <div slot="header">
        <span class="header-text">学习详细数据</span>
        <el-button id="exportBtn" type="primary" icon="el-icon-download" @click="exportLearnDetails">导出</el-button>
        <el-button id="exportBtn" type="primary" icon="el-icon-download" @click="exportAllClassLearnDetails">导出所有班级</el-button>
      </div>
      <div class="content">
        <el-table @sort-change="sortChange" border :data="learnDetails"  :default-sort = "{prop: 'name', order: 'ascending'}" >
           <el-table-column
            type="index">
          </el-table-column>
          <el-table-column
            prop="name"
            label="学生名称"
            sortable="custom">
          </el-table-column>
          <el-table-column
            prop="studyMins"
            label="学习时长/min"
            sortable="custom"
            align="center">
          </el-table-column>
          <el-table-column
            prop="daysMore5Mins"
            label="学习时长分布"
            sortable="custom"
            align="center">
          </el-table-column>
          <el-table-column
            prop="points"
            label="积分"
            sortable="custom"
            align="center">
          </el-table-column>
          <el-table-column
            prop="stars"
            label="星星"
            sortable="custom"
            align="center">
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
  </section>
</div>
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full'
import $ from 'jquery'
import {baseUrl} from 'api/base'
import {mapGetters} from 'vuex'
import {loadLearnDetails} from 'api/learn-details'
import {getLastWeek, extractArrFromObj} from 'common/js/app-utils'
import {sortChange, pagination} from 'common/js/common-utils'
import {loadClasses} from 'api/condition'
export default {
  computed: {
    ...mapGetters([
      'customers',
      'pickerOptions',
      'orgTypes',
      'orgClasses'
    ])
  },
  data () {
    return {
      currentDate: new Date(),
      dateRange: [],
      classes: [],
      filters: {
        customer: '',
        classId: '',
        orgClass: [],
        dateRange: [],
        orgType: ''
      },
      // pagination
      page: 1,
      total: 0,
      pageSize: 10,
      userListAll: [],
      // business
      learnDetails: []
    }
  },
  components: {
    IEcharts
  },
  mounted () {
    this.query()
  },
  methods: {
    sortChange (obj) {
      sortChange(obj, this.userListAll)
      this.handleCurrentChange(1)
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.pagination(1, val, this.userListAll)
    },
    handleCurrentChange (val) {
      this.page = val
      this.pagination(val, this.pageSize, this.userListAll)
    },
    exportLearnDetails () {
      if (this.filters.orgClass.length === 0 && this.filters.classId === '') {
        this.$message.error('请先选择一个班级')
        return false
      }
      let form = $('<form>')
      form.attr('style', 'display:none')
      form.attr('target', '')
      form.attr('method', 'post')
      form.attr('action', baseUrl + 'exports/exportLearnDetails')
      let input1 = $('<input>')
      let input2 = $('<input>')
      input1.attr('type', 'hidden')
      input1.attr('name', 'conditionStr')
      input1.attr('value', JSON.stringify(this.filters))
      input2.attr('type', 'hidden')
      input2.attr('name', 'token')
      input2.attr('value', localStorage.getItem('default_auth_token'))
      $('body').append(form)
      form.append(input1)
      form.append(input2)
      form.submit()
    },
    exportAllClassLearnDetails () {
      if (this.filters.orgClass.length === 0 && this.filters.customer === '') {
        this.$message.error('请先选择一个学校')
        return false
      }
      let form = $('<form>')
      form.attr('style', 'display:none')
      form.attr('target', '')
      form.attr('method', 'post')
      form.attr('action', baseUrl + 'exports/exportAllClassLearnDetails')
      let input1 = $('<input>')
      let input2 = $('<input>')
      let input3 = $('<input>')
      input1.attr('type', 'hidden')
      input1.attr('name', 'classIds')
      input1.attr('value', this.getExportAllClassQuery())
      input2.attr('type', 'hidden')
      input2.attr('name', 'token')
      input2.attr('value', localStorage.getItem('default_auth_token'))
      input3.attr('type', 'hidden')
      input3.attr('name', 'conditionStr')
      input3.attr('value', JSON.stringify(this.filters))
      $('body').append(form)
      form.append(input1)
      form.append(input2)
      form.append(input3)
      form.submit()
    },
    query () {
      this._showDateRange()
      this._loadLearnDetails(this.filters)
    },
    getExportAllClassQuery () {
      if (this.filters.orgClass === '' && this.filters.customer === '') {
        this.$message.error('请先选择一个学校')
        return
      }
      let arr = []
      if (this.$auth.check('ROLE_QOOCO')) { // 巧口用户
        this.classes.forEach(clazz => arr.push(clazz.group_id))
      } else {
        this.orgClasses.forEach(scoo => {
          if (scoo.value === this.filters.orgClass[0]) {
            scoo.children.forEach(clazz => arr.push(clazz.value))
          }
        })
      }
      return arr.join()
    },
    _showDateRange () {
      let t = this.filters.dateRange
      if (t && t.length === 2) {
        this.dateRange = t
      } else {
        this.dateRange = getLastWeek()
      }
    },
    _loadLearnDetails () {
      this.page = 1
      loadLearnDetails(this.filters)
      .then((res) => {
        this.userListAll = res
        this.handleSizeChange(this.pageSize)
      }, (msg) => {
        this.$message.error(msg)
        this.summary = {}
        this.userListAll = []
        this.handleSizeChange(this.pageSize)
      })
    },
    pagination (page, pageSize, all) {
      this.learnDetails = pagination(page, pageSize, all)
      this.total = all.length
    },
    changeSchool (val) {
      this.filters.classId = ''
      this._loadClasses()
    },
    _loadClasses () {
      // 接口只接受单选，所以这里需要将多选转为单选
      let orgId = this.filters.customer
      let schoolIds = [orgId]
      loadClasses(schoolIds)
      .then((res) => {
        let ret = []
        extractArrFromObj(res, 'groups').every(arr => ret.push(...arr))
        this.classes = ret
      }, (msg) => {
        this.classes = []
      })
    }
  }
}
</script>


<style lang="stylus" scoped>
  @import '~common/stylus/base'
</style>



// WEBPACK FOOTER //
// src/components/learn-details/learn-details.vue